import {tokens} from '@commercial-helios/ui/theme'
import React from 'react'
import styled from 'styled-components'

import type {Props as RichTextProps} from '@helios/shared/components/rich-text'
import type ImageSource from '@helios/shared/types/image'
import mq from '@helios/shared/utils/media-query'

import MediaItem from '../media-item'

interface Item {
    title: string
    body?: RichTextProps['content']
    image?: ImageSource
}

export interface Props {
    items: Item[]
}

const MediaList = ({items}: Props) => (
    <Wrapper>
        {items.map((item, i) => (
            <MediaItem {...item} as="li" key={i} />
        ))}
    </Wrapper>
)

export default MediaList

const Wrapper = styled.ol`
    display: grid;
    padding: 0;
    margin: 0;
    list-style-type: none;
    gap: ${tokens.spacing40};

    li {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: ${tokens.spacing8} ${tokens.spacing20};

        ${mq.min('sm')} {
            gap: ${tokens.spacing12} ${tokens.spacing40};
        }
    }
`
